module.exports = __webpack_public_path__ + "static/media/Joao_Filipe.d8f4ccf1.jpg";